import {createApp} from 'vue'
import Store from 'store'
import Overlay from './SiteNavigationOverlay.vue'

const overlayEl = '.nlx-component--overlay'
const overlayDOM = document.querySelector(overlayEl)
const overlayComponent = createApp(Overlay).use(Store)

if(overlayDOM){
    overlayComponent.mount(overlayEl)
}

